//CRN_20260622 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { eDatePrecision } from 'src/app/core/enums';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })

export class DatePrecisionService {

  constructor(
    private configSystemService: ConfigSystemService,
    private exceptionsService  : ExceptionsService
  ) { }

  public composeToFullDate(year: number, month: number=1, day: number=1): string {
    try {
      const mm=String(month).padStart(2, "0");
      const dd=String(day  ).padStart(2, "0");

      return `${year}-${mm}-${dd}T00:00:00`;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  public getDisplayFormat(param: string, defaultValue: string): string {
    try {
      switch (this.getPrecision(param, defaultValue)) {
        case eDatePrecision.MonthYear:
          return "MM/yyyy";

        case eDatePrecision.Year:
          return "yyyy";

        default:
          return "dd/MM/yyyy";
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "dd/MM/yyyy";
    }
  }

  public getPrecision(param: string, defaultValue: string): eDatePrecision {
    try {
      const raw   =this.configSystemService.getValue(param, defaultValue);
      const value =(raw ?? "").trim().toLowerCase();

      switch (value) {
        case eDatePrecision.MonthYear:
          return eDatePrecision.MonthYear;

        case eDatePrecision.Year:
          return eDatePrecision.Year;

        case eDatePrecision.DayMonthYear:
          return eDatePrecision.DayMonthYear;

        default:
          return eDatePrecision.DayMonthYear;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return eDatePrecision.DayMonthYear;
    }
  }
}
